var sQtext = '[^\\x0d\\x22\\x5c\\x80-\\xff]';
var sDtext = '[^\\x0d\\x5b-\\x5d\\x80-\\xff]';
var sAtom = '[^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+';
var sQuotedPair = '\\x5c[\\x00-\\x7f]';
var sDomainLiteral = '\\x5b(' + sDtext + '|' + sQuotedPair + ')*\\x5d';
var sQuotedString = '\\x22(' + sQtext + '|' + sQuotedPair + ')*\\x22';
var sDomain_ref = sAtom;
var sSubDomain = '(' + sDomain_ref + '|' + sDomainLiteral + ')';
var sWord = '(' + sAtom + '|' + sQuotedString + ')';
var sDomain = sSubDomain + '(\\x2e' + sSubDomain + ')*';
var sLocalPart = sWord + '(\\x2e' + sWord + ')*';
var sAddrSpec = sLocalPart + '\\x40' + sDomain; // complete RFC822 email address spec
var sValidEmail = '^' + sAddrSpec + '$'; // as whole string

var reValidEmail = new RegExp(sValidEmail, 'i');

class Rex {
    static common = {
        email: reValidEmail,
        //phone: new RegExp('^\\d{0,2}[-. ]{0,1}\\d{3}[-. ]{0,1}\\d{3}[-. ]{0,1}\\d{4}(\\s{0,1}x\\d{1,5}){0,1}$', 'i'),
        phone: new RegExp('^[x0-9+ *.-]{7,25}$', 'i'),
        //url: new RegExp(String.raw`^(http\://|https\://){0,1}([a-zA-Z0-9\.\-]+(\:[a-zA-Z0-9\.&amp;%\$\-]+)*@)?((25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9])\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])|([a-zA-Z0-9\-]+\.)*[a-zA-Z0-9\-]+\.[a-zA-Z]{2,4})(\:[0-9]+)?(/[^/][a-zA-Z0-9\.\,\?\'\\/\+&amp;%\$#\=~_\-@]*)*$`, 'i')
        url: new RegExp('^(http\\://|https\\://){0,1}([a-zA-Z0-9\\.\\-]+(\\:[a-zA-Z0-9\\.&amp;%\\$\\-]+)*@)?((25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9])\\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])|([a-zA-Z0-9\\-]+\\.)*[a-zA-Z0-9\\-]+\\.[a-zA-Z]{2,4})(\\:[0-9]+)?(/[^/][a-zA-Z0-9\\.\\,\\?\\\'\\\\/\\+&amp;%\\$#\\=~_\\-@]*)*$', 'i')
    }
}

function validateScalar(fieldDef, value){
    console.log('validateScalar', fieldDef.label, value);
    var errors = [];

    if (fieldDef == null) {
        throw Error('fieldDev cannot be null');
    }

    let fd = fieldDef;

    if (fd.isRequired)
    {
        if (value == null ||
            (typeof(value) == 'string' && value.trim().length === 0)) {
            errors.push(fd.label + ' is required');
            return errors;
        }
    }

    if (value != null) {
        switch(fd.dataType){
            case "INTEGER":
                if (isNaN(parseInt(value))) {
                    errors.push('Expected a whole number');
                }
                break;
            case "DECIMAL":
                if (isNaN(parseFloat(value))) {
                    errors.push('Expected a number');
                }
                break;
            case "BOOLEAN":
                if (typeof(value) !== 'boolean'){
                    errors.push('Expected true/false');
                }
                break;
            case "DATE":
            case "DATETIME":
                if (isNaN(Date.parse(value))) {
                    errors.push('Expected a valid date format');
                }
                break;
            default:
                break;
        }

        for (var v = 0; v < fd.validators.length; v++) {
            var vd = fd.validators[v];
            switch (vd.type) {
                case 'regex':
                    if (typeof(value) === 'string' && value.length > 0) {
                        if (!new RegExp(vd.settings.pattern, vd.settings.opts || '').test(value)) {
                            errors.push(vd.errorMessage);
                        }
                    }
                    break;
                default:
                    if (vd.type in Rex.common) {
                        if (typeof(value) === 'string' && value.length > 0) {
                            if (!Rex.common[vd.type].test(value)) {
                                errors.push(vd.errorMessage);
                            }
                        }
                    }
                    else {
                        throw Error("Unsupported validator");
                    }
                    break;
            }
        }
    }

    return errors;
}

function validate(fieldDef, value) {
    var errors = [];

    if (fieldDef == null){
        throw Error('fieldDef cannot be null');
    }

    let fd = fieldDef;

    if (['ARRAY', 'SET'].indexOf(fd.listType) > -1) {
        if (fd.isRequired) {
            if (value == null ||
                    (typeof(value) === 'string' && value.trim().length === 0) ||
                    (value instanceof Array && value.length == 0)) {
                errors.push(fd.label + ' is required');
                return errors;
            }
        }
        else {
            if (value !== null) {
                for (let i = 0; i < value.length; i++) {
                    errors = validateScalar(fd, value[i]);
                    if (errors.length > 0) {
                        return errors;
                    }
                }
            }
        }
    }
    else {
        return validateScalar(fd, value);
    }

    return errors;
}

export { validate, validateScalar };